(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wallify-collection-explorer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-explorer-tab]');
  if (tab) {
    const explorer = tab.closest('.wallify-explorer');
    explorer.querySelectorAll('[data-explorer-tab]').forEach(button => { const active = button === tab; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
    explorer.querySelectorAll('[data-explorer-pane]').forEach(pane => { pane.hidden = pane.dataset.explorerPane !== tab.dataset.explorerTab; });
    return;
  }
  const button = event.target.closest('.wallify-explorer-footer button[type="submit"]');
  if (!button) return;
  const form = document.getElementById(button.getAttribute('form'));
  if (!form || !form.checkValidity()) return;
  event.preventDefault();
  const params = new URLSearchParams(new FormData(form));
  for (const [key, value] of [...params.entries()]) {
    if (value === '') params.delete(key);
  }
  const destination = new URL(form.action, window.location.origin);
  destination.search = params.toString();
  window.location.assign(destination.href);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wallify-desktop-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const hoverDesktop = window.matchMedia('(min-width: 1070px) and (hover: hover) and (pointer: fine)');
  function initializeNavigation() {
    document.querySelectorAll('.header__inline-menu:not([data-wallify-navigation])').forEach((nav) => {
      const entries = Array.from(nav.querySelectorAll(':scope > .list-menu > .list-menu__has-mega, :scope > .list-menu > .wallify-nav-item')).map((item) => {
        const details = item.querySelector(':scope > .wallify-nav-details');
        return { item, details, trigger: details ? details.querySelector(':scope > summary') : item.querySelector(':scope > a'), panel: details ? details.querySelector(':scope > .wallify-nav-panel') : item.querySelector(':scope > .mega-menu__content'), timer: null };
      }).filter((entry) => entry.trigger && entry.panel);
      if (!entries.length) return;
      nav.setAttribute('data-wallify-navigation', '');
      function close(entry) {
        window.clearTimeout(entry.timer);
        entry.item.removeAttribute('data-wallify-open');
        entry.trigger.setAttribute('aria-expanded', 'false');
        entry.panel.inert = true;
        if (entry.details) entry.details.open = false;
      }
      function positionPanel(entry) {
        entry.panel.style.setProperty('--wallify-viewport-width', `${document.documentElement.clientWidth}px`);
        const itemLeft = entry.item.getBoundingClientRect().left;
        const panelWidth = entry.panel.getBoundingClientRect().width;
        const left = (entry.panel.classList.contains('wallify-art-menu--ordered') || entry.panel.classList.contains('wallify-clothing-panel')) ? 0 : Math.max(24, Math.min(itemLeft - 24, document.documentElement.clientWidth - panelWidth - 24));
        entry.panel.style.setProperty('--wallify-panel-left', `${left - itemLeft}px`);
        entry.panel.style.setProperty('--wallify-menu-max-height', `${Math.max(140, window.innerHeight - entry.panel.getBoundingClientRect().top - 20)}px`);
      }
      function open(entry) {
        window.clearTimeout(entry.timer);
        entries.forEach((other) => { if (other !== entry) close(other); });
        entry.item.setAttribute('data-wallify-open', '');
        entry.trigger.setAttribute('aria-expanded', 'true');
        entry.panel.inert = false;
        if (entry.details) entry.details.open = true;
        positionPanel(entry);
      }
      entries.forEach((entry, index) => {
        if (!entry.panel.id) entry.panel.id = `${nav.closest('.shopify-section')?.id || 'wallify-header'}-desktop-panel-${index}`;
        entry.trigger.setAttribute('aria-controls', entry.panel.id);
        const href = entry.trigger.getAttribute('href') || '';
        const toggleOnly = !!entry.details || href === '' || href.endsWith('#');
        if (!entry.details && toggleOnly) entry.trigger.setAttribute('role', 'button');
        close(entry);
        entry.item.addEventListener('pointerenter', (event) => {
          if (!hoverDesktop.matches || event.pointerType === 'touch') return;
          window.clearTimeout(entry.timer);
          if (!entry.item.hasAttribute('data-wallify-open')) entry.timer = window.setTimeout(() => open(entry), 110);
        });
        entry.item.addEventListener('pointerleave', (event) => {
          if (!hoverDesktop.matches || event.pointerType === 'touch') return;
          window.clearTimeout(entry.timer);
          entry.timer = window.setTimeout(() => {
            if (entry.item.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
            close(entry);
          }, 220);
        });
        entry.item.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!entry.item.contains(document.activeElement) && !entry.item.matches(':hover')) close(entry);
          });
        });
        entry.trigger.addEventListener('click', (event) => {
          if (!toggleOnly) return;
          event.preventDefault();
          if (entry.item.hasAttribute('data-wallify-open')) close(entry);
          else open(entry);
        });
        if (entry.details) entry.details.addEventListener('toggle', () => {
          if (entry.details.open && !entry.item.hasAttribute('data-wallify-open')) open(entry);
          else if (!entry.details.open && entry.item.hasAttribute('data-wallify-open')) close(entry);
        });
        entry.item.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            entry.trigger.focus();
            close(entry);
          } else if (event.target === entry.trigger && event.key === 'ArrowDown') {
            event.preventDefault();
            open(entry);
            window.requestAnimationFrame(() => {
              if (entry.item.hasAttribute('data-wallify-open')) entry.panel.querySelector('a[href], button:not([disabled])')?.focus();
            });
          } else if (!entry.details && toggleOnly && event.target === entry.trigger && event.key === ' ') {
            event.preventDefault();
            if (entry.item.hasAttribute('data-wallify-open')) close(entry);
            else open(entry);
          }
        });
      });
      document.addEventListener('pointerdown', (event) => {
        if (!nav.contains(event.target)) entries.forEach(close);
      });
      nav.querySelectorAll(':scope > .list-menu > li').forEach((item) => {
        if (entries.some((entry) => entry.item === item)) return;
        item.addEventListener('pointerenter', () => { if (hoverDesktop.matches) entries.forEach(close); });
        item.addEventListener('focusin', () => entries.forEach(close));
      });
      hoverDesktop.addEventListener('change', () => entries.forEach(close));
      let frame;
      const reposition = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = null;
          entries.forEach((entry) => { if (entry.item.hasAttribute('data-wallify-open')) positionPanel(entry); });
        });
      };
      window.addEventListener('resize', reposition);
      window.addEventListener('scroll', reposition, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeNavigation, { once: true });
  else initializeNavigation();
  document.addEventListener('shopify:section:load', initializeNavigation);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wallify-premium-frame"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wallify-premium-frame')) {
    customElements.define('wallify-premium-frame', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.config = JSON.parse(this.querySelector('[data-premium-config]').textContent);
        this.checkbox = this.querySelector('[data-premium-radio]');
        this.previewNodes = new Set();
        this.hiddenPremiumColors = new Map();
        this.previewObserver = new ResizeObserver(() => this.updatePreview(this.currentBaseVariant()));
        this.reverseMap = new Map(Object.entries(this.config.map).filter(([, id]) => id).map(([base, id]) => [String(id), String(base)]));
        this.checkbox.checked = new URL(location.href).searchParams.get('frame_upgrade') === 'premium' || (this.config.native && this.reverseMap.has(String(this.config.initialVariant)));
        this.checkbox.addEventListener('change', () => this.refresh(), { signal: this.abortController.signal });
        customElements.whenDefined('variant-selects').then(() => {
          if (!this.isConnected) return;
          this.picker = document.getElementById(`variant-selects-${this.dataset.section}`);
          if (!this.picker) return;
          this.picker.addEventListener('change', () => queueMicrotask(() => this.refresh()), { signal: this.abortController.signal });
          if (typeof subscribe === 'function') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
              if (event.data.sectionId === this.dataset.section) this.refresh();
            });
          }
          this.forms = [this.dataset.form, `${this.dataset.form}-sticky`, `product-form-installment-${this.dataset.section}`]
            .map(id => document.getElementById(id)).filter(Boolean);
          this.forms.forEach(form => {
            form.addEventListener('formdata', event => {
              if (this.selectedPremium) event.formData.set('id', this.selectedPremium.id);
            }, { signal: this.abortController.signal });
          });
          if (this.config.native) {
            const group = Array.from(this.picker.children).filter(el => el.classList.contains('product-form__input'))[0];
            const controls = Array.from(group?.querySelectorAll('input[type="radio"], select option') || []);
            const premiumMaterial = this.picker.getVariantData().find(v => this.reverseMap.has(String(v.id)))?.options[0];
            const control = controls.find(c => c.value === premiumMaterial);
            if (control) {
              control.hidden = true;
              control.labels?.[0]?.setAttribute('data-wallify-native-premium-hidden', '');
              control.labels?.[0]?.style.setProperty('display', 'none', 'important');
              const baseId = this.reverseMap.get(String(this.config.initialVariant));
              const base = this.picker.getVariantData().find(v => String(v.id) === baseId);
              if (base) {
                const standard = controls.find(c => c.value === base.options[0]);
                if (standard?.tagName === 'OPTION') {
                  standard.parentElement.value = standard.value;
                  standard.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
                } else if (standard) {
                  standard.checked = true;
                  standard.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }
          }
          this.refresh();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.unsubscribe?.();
        this.previewObserver?.disconnect();
        this.restorePremiumColors();
        this.previewNodes?.forEach(preview => {
          delete preview.dataset.frameComparison;
          delete preview.dataset.premium;
          preview.style.removeProperty('--wallify-comparison-border');
          preview.querySelector('.wallify-frame-preview__finish')?.remove();
        });
      }

      currentBaseVariant() {
        const containers = Array.from(this.picker.children).filter(el => el.classList.contains('product-form__input'));
        const options = containers.map(el => el.querySelector('select')?.value ?? el.querySelector('input:checked')?.value);
        if (options.some(value => !value)) return null;
        return this.picker.getVariantData().find(variant => variant.options.every((value, index) => value === options[index]));
      }

      priceForVariant(variant) {
        if (!this.checkbox?.checked) return variant.price;
        const premiumId = this.config.map[String(variant.id)];
        return this.config.variants.find(candidate => candidate.id === premiumId)?.price ?? variant.price;
      }


      pricingForVariant(variant) {
        const base = this.config.variants.find(candidate => candidate.id === variant.id);
        const standard = { price: variant.price, compareAt: variant.compare_at_price ?? base?.compareAt ?? 0 };
        if (!this.checkbox?.checked) return standard;
        const premiumId = this.config.map[String(variant.id)];
        const premium = this.config.variants.find(candidate => candidate.id === premiumId);
        return premium?.available && (this.config.native || premium.price >= variant.price)
          ? { price: premium.price, compareAt: premium.compareAt }
          : standard;
      }

      updateUpgradePrice(base, premium, baseCompareAt) {
        const current = this.querySelector('[data-premium-extra-price]');
        const compare = this.querySelector('[data-premium-extra-compare]');
        const formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, signDisplay: 'always' });
        const extra = base && premium ? premium.price - base.price : null;
        const standardBefore = Number(baseCompareAt) > 0 ? Number(baseCompareAt) : Number(base?.price || 0);
        const premiumBefore = Number(premium?.compareAt) > 0 ? Number(premium.compareAt) : Number(premium?.price || 0);
        const extraBefore = premiumBefore - standardBefore;
        const discounted = extra !== null && extraBefore > extra;
        current.textContent = extra === null ? '' : formatter.format(extra / 100);
        compare.textContent = discounted ? formatter.format(extraBefore / 100) : '';
        compare.hidden = !discounted;
        current.setAttribute('aria-label', (discounted ? this.config.salePriceLabel : this.config.regularPriceLabel) + ': ' + current.textContent);
        compare.setAttribute('aria-label', this.config.regularPriceLabel + ': ' + compare.textContent);
      }

      updatePreview(base) {
        if (!base || !this.picker) return;
        const productRoot = this.closest('.product');
        productRoot?.querySelectorAll('wallify-frame-preview:not([data-lens-clone])').forEach(preview => {
          if (!this.previewNodes.has(preview)) {
            this.previewNodes.add(preview);
            this.previewObserver.observe(preview);
          }
          preview.dataset.frameComparison = 'true';
          preview.dataset.premium = String(!!this.selectedPremium);
          const thumbnail = preview.classList.contains('wallify-frame-preview--thumbnail');
          preview.style.removeProperty('--wallify-comparison-border');
          const picture = preview.querySelector('.wallify-frame-preview__picture');
          if (picture && !picture.querySelector('.wallify-grain-rails')) {
            const rails = document.createElement('span');
            rails.className = 'wallify-grain-rails';
            rails.setAttribute('aria-hidden','true');
            ['top','right','bottom','left'].forEach(side => {
              const rail = document.createElement('i'); rail.className = 'wallify-grain-rail wallify-grain-rail--' + side; rails.appendChild(rail);
            });
            picture.appendChild(rails);
          }
          if (thumbnail) return;
          let label = preview.querySelector('.wallify-frame-preview__finish');
          if (!label) {
            label = document.createElement('span');
            label.className = 'wallify-frame-preview__finish';
            label.setAttribute('aria-hidden', 'true');
            preview.appendChild(label);
          }
          label.textContent = this.selectedPremium ? this.dataset.previewPremium : this.dataset.previewClassic;
          const currentLabel = preview.getAttribute('aria-label') || preview.dataset.productTitle;
          const finishLabels = [this.dataset.previewClassic, this.dataset.previewPremium];
          const cleanLabel = finishLabels.reduce((value, finish) => value.replace(' — ' + finish, ''), currentLabel);
          preview.setAttribute('aria-label', cleanLabel + ' — ' + label.textContent);
        });
      }

      restorePremiumColors() {
        this.hiddenPremiumColors?.forEach((previous, control) => {
          control.disabled = previous.disabled;
          control.removeAttribute('data-wallify-premium-hidden');
          previous.label?.removeAttribute('data-wallify-premium-hidden');
        });
        this.hiddenPremiumColors?.clear();
      }

      updatePremiumColors(base) {
        this.restorePremiumColors();
        if (!this.selectedPremium || !base) return;
        const colorGroup = Array.from(this.picker.children).filter(el => el.classList.contains('product-form__input'))[2];
        if (!colorGroup) return;
        const variants = this.picker.getVariantData();
        colorGroup.querySelectorAll('input[type="radio"], select option').forEach(control => {
          if (control.tagName === 'INPUT' && !control.labels?.length) return;
          const variant = variants.find(candidate => candidate.options[0] === base.options[0] && candidate.options[1] === base.options[1] && candidate.options[2] === control.value);
          const mappedId = variant && this.config.map[String(variant.id)];
          const premium = this.config.variants.find(candidate => candidate.id === mappedId);
          if (premium?.available && (this.config.native || premium.price >= variant.price)) return;
          const label = control.labels?.[0];
          this.hiddenPremiumColors.set(control, { disabled: control.disabled, label });
          control.disabled = true;
          control.setAttribute('data-wallify-premium-hidden', '');
          label?.setAttribute('data-wallify-premium-hidden', '');
        });
      }

      refresh() {
        if (!this.picker || !this.isConnected) return;
        const base = this.currentBaseVariant();
        const isFramed = !!base && Object.prototype.hasOwnProperty.call(this.config.map, String(base.id));
        const premiumId = base ? this.config.map[String(base.id)] : null;
        const premium = this.config.variants.find(variant => variant.id === premiumId);
        const available = isFramed && premium?.available && (this.config.native || premium.price >= base.price);
        this.hidden = !isFramed;
        this.checkbox.disabled = !available;
        if (!available) this.checkbox.checked = false;
        const baseCompareAt = base?.compare_at_price ?? this.config.variants.find(variant => variant.id === base?.id)?.compareAt;
        this.updateUpgradePrice(base, available ? premium : null, baseCompareAt);
        this.selectedPremium = this.checkbox.checked ? premium : null;
        this.dataset.selected = String(!!this.selectedPremium);
        this.updatePremiumColors(base);
        this.querySelector('[data-premium-unavailable]').hidden = !isFramed || !!available;
        if (base) {
          this.forms.forEach(form => {
            const input = form.querySelector('[name="id"]');
            const selectedId = String(this.selectedPremium?.id || base.id);
            if (input && input.value !== selectedId) {
              input.value = selectedId;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        [`price-${this.dataset.section}`, `price-${this.dataset.section}-sticky`].forEach(id => {
          const container = document.getElementById(id);
          if (!container) return;
          container.classList.toggle('wallify-premium-active-price', !!this.selectedPremium);
          let price = container.querySelector('[data-wallify-premium-price]');
          if (!this.selectedPremium) { price?.remove(); return; }
          if (!price) {
            price = document.createElement('div');
            price.dataset.wallifyPremiumPrice = '';
            price.className = 'price';
            container.appendChild(price);
          }
          price.replaceChildren();
          const compareAt = Number(this.selectedPremium.compareAt) || 0;
          const onSale = compareAt > this.selectedPremium.price;
          const offer = Number(this.config.offerPercent) || 0;
          const saving = onSale ? Math.floor((compareAt - this.selectedPremium.price) * 100 / compareAt) : 0;
          // Same rule as snippets/price.liquid: the category label inside its band, otherwise the real saving rounded down
          const inBand = offer > 0 && saving >= offer && saving < offer + 6;
          const showBadge = onSale && saving > 0;
          price.className = onSale ? 'price price--on-sale' + (showBadge ? ' price--show-badge' : '') : 'price';
          if (onSale) {
            const prices = document.createElement('div');
            prices.className = 'price__container';
            const sale = document.createElement('div');
            sale.className = 'price__sale';
            const saleLabel = document.createElement('span');
            saleLabel.className = 'visually-hidden visually-hidden--inline';
            saleLabel.textContent = this.config.salePriceLabel;
            const current = document.createElement('span');
            current.className = 'price-item price-item--sale price-item--last';
            current.textContent = this.selectedPremium.money;
            const regularLabel = document.createElement('span');
            regularLabel.className = 'visually-hidden visually-hidden--inline';
            regularLabel.textContent = this.config.regularPriceLabel;
            const compare = document.createElement('s');
            compare.className = 'price-item price-item--regular';
            compare.textContent = this.selectedPremium.compareMoney;
            sale.append(saleLabel, current, regularLabel, compare);
            prices.appendChild(sale);
            price.append(prices);
            if (showBadge) {
              const badge = document.createElement('span');
              badge.className = `badge price__badge-sale wallify-offer-badge wallify-offer--${offer}`;
              badge.textContent = `−${inBand ? offer : saving}%`;
              price.append(badge);
            }
          } else {
            price.textContent = this.selectedPremium.money;
          }
        });
        this.updatePreview(base);
        this.picker.dispatchEvent(new CustomEvent('wallify:premium-change'));
        const url = new URL(location.href);
        if (this.selectedPremium) url.searchParams.set('frame_upgrade', 'premium');
        else url.searchParams.delete('frame_upgrade');
        if (url.href !== location.href) history.replaceState(history.state, '', url);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wallify-product-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wallify-product-experience')) {
    customElements.define('wallify-product-experience', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.picker = this.root?.querySelector('variant-selects');
        if (!this.picker) return;
        customElements.whenDefined('variant-selects').then(() => {
          if (!this.isConnected) return;
          const groups = Array.from(this.picker.children).filter(el => el.classList.contains('product-form__input'));
          groups[0]?.classList.add('wallify-material-choice');
          groups[1]?.classList.add('wallify-size-choice');
          this.colorGroup = groups[2];
          this.decorateColors();
          this.sticky = this.root.querySelector('product-add-to-cart-sticky') || document.querySelector(`product-add-to-cart-sticky[data-section="${this.dataset.section}"]`);
          this.sticky?.classList.add('wallify-pdp-sticky');
          this.mainPrice = this.root.querySelector('.wallify-pdp-purchase-price');
          this.footer = document.querySelector('footer');
          const signal = this.abortController.signal;
          this.schedule = () => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(() => { this.raf = 0; this.updateSticky(); });
          };
          this.picker.addEventListener('change', () => queueMicrotask(this.schedule), { signal });
          this.picker.addEventListener('wallify:premium-change', this.schedule, { signal });
          window.addEventListener('scroll', this.schedule, { passive: true, signal });
          window.addEventListener('resize', this.schedule, { passive: true, signal });
          this.resizeObserver = new ResizeObserver(this.schedule);
          this.resizeObserver.observe(this.root);
          this.schedule();
        });
      }
      decorateColors() {
        if (!this.colorGroup) return;
        this.colorGroup.classList.add('wallify-color-choice');
        this.colorGroup.querySelectorAll('label.swatch-color').forEach(label => {
          if (label.querySelector('.wallify-color-dot')) return;
          const text = label.querySelector('.sr-only')?.textContent.trim() || '';
          const dot = document.createElement('span');
          dot.className = 'wallify-color-dot';
          dot.setAttribute('aria-hidden', 'true');
          const caption = document.createElement('span');
          caption.className = 'wallify-color-caption';
          caption.setAttribute('aria-hidden', 'true');
          caption.textContent = text;
          label.append(dot, caption);
        });
      }
      updateSticky() {
        this.sticky?.handleScroll?.();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.sticky?.classList.remove('wallify-pdp-sticky', 'wallify-pdp-sticky-visible');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wallify-search-discovery"] && !Shopify.designMode) return;
  try {
    (()=>{const align=()=>{const trigger=document.querySelector('.wallify-header-search');if(!trigger)return;const r=trigger.getBoundingClientRect();const root=document.documentElement;root.style.setProperty('--wallify-search-top',Math.max(16,r.top)+'px');root.style.setProperty('--wallify-search-width',Math.min(1100,innerWidth-48)+'px');root.style.setProperty('--wallify-search-left','50%')};document.addEventListener('click',e=>{if(e.target.closest('[data-target="drawer-search"]'))align()},true);window.addEventListener('resize',align)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wallify-set-frame-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wallify-set-frame-preview')) {
    customElements.define('wallify-set-frame-preview', class extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.product');
        this.abortController = new AbortController();
        this.resizeObserver = new ResizeObserver(() => this.layoutFrames());
        this.resizeObserver.observe(this);
        if (this.querySelector('.wallify-set-frame-grid')?.dataset.count === '4') {
          window.addEventListener('resize', () => this.layoutFrames(), { signal: this.abortController.signal });
        }
        this.schedule = event => {
          if (!event.target.closest?.('variant-selects')) return;
          if (this.pending) cancelAnimationFrame(this.pending);
          this.pending = requestAnimationFrame(() => { this.pending = null; if (this.isConnected) this.update(true); });
        };
        this.productRoot?.addEventListener('change', this.schedule, { signal: this.abortController.signal });
        this.productRoot?.addEventListener('wallify:premium-change', this.schedule, { capture: true, signal: this.abortController.signal });
        customElements.whenDefined('variant-selects').then(() => {
          if (this.isConnected) this.update(false);
        });
      }
      disconnectedCallback() { this.abortController?.abort(); this.resizeObserver?.disconnect(); if (this.pending) cancelAnimationFrame(this.pending); }
      layoutFrames() {
        const grid = this.querySelector('.wallify-set-frame-grid');
        const gallery = this.closest('gallery-carousel');
        const main = gallery?.querySelector('[id^="Main-Carousel"]');
        const galleryWidth = main?.getBoundingClientRect().width || this.getBoundingClientRect().width;
        if (!grid || !galleryWidth || this.querySelector('[data-set-stage]')?.hidden) return;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const singleBorder = mobile ? 16 : Math.min(28, Math.max(10, window.innerWidth * .022));
        const fallbackRatio = Number(getComputedStyle(this).getPropertyValue('--wallify-set-size-ratio')) || 5 / 7;
        const frames = Array.from(grid.children);
        const stage = this.querySelector('[data-set-stage]');
        const fourPrints = grid.dataset.count === '4' && frames.length === 4;
        let availableWidth;
        let availableHeight;
        if (fourPrints) {
          const stageWidth = stage.getBoundingClientRect().width || galleryWidth;
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const controls = gallery?.querySelector(':scope > .wgm-controls');
          const controlsHeight = controls && !controls.hidden ? controls.getBoundingClientRect().height : 0;
          stage.style.height = Math.min(stageWidth, Math.max(1, window.innerHeight - headerHeight - controlsHeight - 32)) + 'px';
          const stageStyle = getComputedStyle(stage);
          availableWidth = stageWidth - parseFloat(stageStyle.paddingLeft) - parseFloat(stageStyle.paddingRight);
          const textHeight = Array.from(stage.querySelectorAll('.wallify-set-frame-caption, .wallify-set-frame-note')).reduce((height, text) => {
            const textStyle = getComputedStyle(text);
            return height + text.getBoundingClientRect().height + parseFloat(textStyle.marginTop) + parseFloat(textStyle.marginBottom);
          }, 0);
          availableHeight = stage.clientHeight - parseFloat(stageStyle.paddingTop) - parseFloat(stageStyle.paddingBottom) - textHeight - 12;
          grid.style.width = Math.max(1, availableWidth) + 'px';
        }
        const sizeFrames = () => frames.forEach(frame => {
          const picture = frame.querySelector('.wallify-frame-preview__picture');
          const artwork = picture?.querySelector('img');
          const width = frame.getBoundingClientRect().width;
          if (!picture || !artwork || !width) return;
          const landscape = frame.classList.contains('wallify-frame-preview--landscape');
          const intrinsicWidth = Number(artwork.getAttribute('width'));
          const intrinsicHeight = Number(artwork.getAttribute('height'));
          const cropWidth = parseFloat(artwork.style.width);
          const cropHeight = parseFloat(artwork.style.height);
          const artRatio = landscape ? 1 / fallbackRatio : fallbackRatio;
          if (intrinsicWidth > 0 && intrinsicHeight > 0 && intrinsicWidth !== intrinsicHeight && !(cropWidth > 0 && cropHeight > 0)) {
            frame.dataset.setArtworkComplete = 'true';
          }
          const multiplier = Number(getComputedStyle(frame).getPropertyValue('--wallify-frame-multiplier')) || 1;
          const borderRatio = singleBorder / (galleryWidth * (landscape ? .64 : .5));
          const baseBorder = borderRatio * width / (1 + 2 * borderRatio * multiplier);
          frame.style.setProperty('--wallify-classic-border', baseBorder + 'px');
          const actualBorder = parseFloat(getComputedStyle(picture).borderLeftWidth);
          const innerWidth = width - 2 * actualBorder;
          const height = innerWidth / artRatio + 2 * actualBorder;
          if (height > 0) frame.style.setProperty('--wallify-set-outer-ratio', width / height);
        });
        sizeFrames();
        if (fourPrints) {
          const gridStyle = getComputedStyle(grid);
          const rowGap = parseFloat(gridStyle.rowGap) || 0;
          const columnGap = parseFloat(gridStyle.columnGap) || 0;
          const outerRatio = Math.min(...frames.map(frame => Number(frame.style.getPropertyValue('--wallify-set-outer-ratio')) || fallbackRatio));
          const heightLimitedWidth = Math.max(1, availableHeight - rowGap) * outerRatio + columnGap;
          grid.style.width = Math.max(1, Math.min(availableWidth, heightLimitedWidth)) + 'px';
          sizeFrames();
        }
      }
      update(moveGallery) {
        const picker = this.productRoot?.querySelector('variant-selects');
        if (!picker) return;
        const groups = Array.from(picker.children).filter(el => el.classList.contains('product-form__input'));
        const sizeGroup = groups[1];
        const sizeSelect = sizeGroup?.querySelector('select');
        const sizeRadio = sizeGroup?.querySelector('input:checked');
        const sizeLabel = sizeSelect?.selectedOptions[0]?.textContent || sizeRadio?.dataset.wallifyDisplayValue || sizeRadio?.value || '';
        const dimensions = sizeLabel.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
        if (dimensions) {
          const sides = dimensions.slice(1).map(value => Number(value.replace(',', '.')));
          const ratio = Math.min(...sides) / Math.max(...sides);
          if (ratio > 0 && Number.isFinite(ratio)) {
            this.style.setProperty('--wallify-set-size-ratio', ratio);
            picker.style.setProperty('--wallify-set-size-ratio', ratio);
            const grid = this.querySelector('.wallify-set-frame-grid');
            const frames = Array.from(grid?.children || []);
            if (frames.length <= 3) {
              grid.style.setProperty('--wallify-set-grid-columns', frames.map(frame => frame.classList.contains('wallify-frame-preview--landscape') ? 'minmax(0,1fr)' : `minmax(0,${ratio}fr)`).join(' '));
            }
          }
        }
        const colorGroup = groups[2];
        const select = colorGroup?.querySelector('select');
        const radios = Array.from(colorGroup?.querySelectorAll('input[type="radio"]') || []);
        const position = select ? select.selectedIndex : radios.findIndex(r => r.checked);
        const framed = position > 0;
        const selected = select ? select.selectedOptions[0] : radios[position];
        const color = selected?.dataset.wallifyDisplayValue || selected?.value || '';
        const premium = this.productRoot.querySelector('wallify-premium-frame')?.dataset.selected === 'true';
        this.querySelector('[data-set-original]').hidden = framed;
        this.querySelector('[data-set-stage]').hidden = !framed;
        this.querySelector('[data-set-caption]').textContent = [this.dataset.previewLabel, premium ? this.dataset.premiumLabel : this.dataset.standardLabel, color, sizeLabel.trim()].filter(Boolean).join(' · ');
        this.layoutFrames();
        const frameValue = selected?.value?.toLowerCase().replace(/[_\s]+/g, '-') || '';
        const finishes = {"no-frame": "transparent", "senza-cornice": "transparent", "sans-cadre": "transparent", "sin-marco": "transparent", "ohne-rahmen": "transparent", "sem-moldura": "transparent", "zonder-lijst": "transparent", "uden-ramme": "transparent", "utan-ram": "transparent", "ilman-kehystä": "transparent", "uten-ramme": "transparent", "bez-ramy": "transparent", "white": "#f5f3ee", "bianco": "#f5f3ee", "blanc": "#f5f3ee", "blanco": "#f5f3ee", "weiß": "#f5f3ee", "branco": "#f5f3ee", "wit": "#f5f3ee", "hvid": "#f5f3ee", "vit": "#f5f3ee", "valkoinen": "#f5f3ee", "hvit": "#f5f3ee", "biały": "#f5f3ee", "natural-wood": "#c6a57f", "wood-frame": "#c6a57f", "legno-naturale": "#c6a57f", "naturale": "#c6a57f", "bois-naturel": "#c6a57f", "madera-natural": "#c6a57f", "naturholz": "#c6a57f", "madeira-natural": "#c6a57f", "natuurlijk-hout": "#c6a57f", "naturtræ": "#c6a57f", "naturträ": "#c6a57f", "luonnonpuu": "#c6a57f", "naturtre": "#c6a57f", "naturalne-drewno": "#c6a57f", "dark-wood": "#71513c", "legno-scuro": "#71513c", "scuro": "#71513c", "bois-foncé": "#71513c", "madera-oscura": "#71513c", "dunkles-holz": "#71513c", "madeira-escura": "#71513c", "donker-hout": "#71513c", "mørkt-træ": "#71513c", "mörkt-trä": "#71513c", "tumma-puu": "#71513c", "mørkt-tre": "#71513c", "ciemne-drewno": "#71513c", "black": "#242424", "nero": "#242424", "noir": "#242424", "negro": "#242424", "schwarz": "#242424", "preto": "#242424", "zwart": "#242424", "sort": "#242424", "svart": "#242424", "musta": "#242424", "czarny": "#242424"};
        picker.style.setProperty('--wallify-set-frame-color', finishes[frameValue] || '#c6a57f');
        if (moveGallery) {
          const gallery = this.closest('gallery-carousel');
          const id = framed ? this.closest('[data-media-id]')?.dataset.mediaId : this.dataset.firstMedia;
          if (id && typeof gallery?.updateCarouselImages === 'function') gallery.updateCarouselImages(id);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
